import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Skeleton } from '@mantine/core'
import { SizePrimitives, useTranslation, useWorkflowForCanvassFeature } from '@front/model'
import { Page, TButton } from '@components'
import { WorkflowStages } from './WorkflowStages'
import { FinalStatuses } from './FinalStatuses'
import { CompanyIcon } from './CompanyIcon'

const CUSTOMER_MAP_HELP_URL = 'https://help.terros.com/en/articles/12315833-customer-map-overview-web'

function CustomerMap(): ReactElement {
  const { t } = useTranslation()

  return (
    <Page>
      <Page.Heading title={t('Customer Map')}>
        <TButton
          component='a'
          href={CUSTOMER_MAP_HELP_URL}
          icon='open_in_new'
          rel='noopener noreferrer'
          target='_blank'
          variant='text'
        >
          {t('Learn more')}
        </TButton>
      </Page.Heading>
      <Page.Content scrollArea>
        <CompanyIcon />
        <CustomerStageSection />
      </Page.Content>
    </Page>
  )
}

const CustomerStageSection = (): ReactElement => {
  const { isEnabled: isWorkflowEnabled, isLoading } = useWorkflowForCanvassFeature()

  if (isLoading) return <Skeleton height={SizePrimitives['24']} />
  if (isWorkflowEnabled) return <WorkflowStages />
  return <FinalStatuses />
}

export const Route = createFileRoute('/settings/tile/')({
  component: CustomerMap,
})
